import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";

interface AddBrandDrugModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (data: {
    name: string;
    contents: string;
    formulation: string;
  }) => void;
  onCancel: () => void;
  trigger: React.ReactNode;
}

const FORMULATIONS = [
  "TABLET",
  "CAPSULE",
  "SYRUP",
  "SACHET",
  "SUPPOSITORY",
  "OINTMENT",
  "LINIMENT",
  "NASAL_SPRAY",
];

const AddBrandDrugModal: React.FC<AddBrandDrugModalProps> = ({
  open,
  onOpenChange,
  onSave,
  onCancel,
  trigger,
}) => {
  const [name, setName] = useState("");
  const [contents, setContents] = useState("");
  const [formulation, setFormulation] = useState(FORMULATIONS[0]);

  const handleSave = () => {
    if (name.trim() && contents.trim() && formulation) {
      onSave({ name: name.trim(), contents: contents.trim(), formulation });
      setName("");
      setContents("");
      setFormulation(FORMULATIONS[0]);
    }
  };

  const handleCancel = () => {
    setName("");
    setContents("");
    setFormulation(FORMULATIONS[0]);
    onCancel();
  };

  return (
    <>
      {trigger}
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="text-black">
          <DialogHeader>
            <DialogTitle>Add Brand Drug</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Brand drug name"
              autoFocus
            />
            <Input
              value={contents}
              onChange={(e) => setContents(e.target.value)}
              placeholder="Contents"
            />
            <div>
              <div className="mb-2 font-medium text-sm">Formulation</div>
              <RadioGroup
                value={formulation}
                onValueChange={setFormulation}
                className="flex flex-wrap gap-2"
              >
                {FORMULATIONS.map((f) => (
                  <RadioGroupItem value={f} id={f} label={f} />
                ))}
              </RadioGroup>
            </div>
          </div>
          <DialogFooter className="mt-4 flex gap-2 justify-end">
            <DialogClose asChild>
              <Button variant="outline" onClick={handleCancel}>
                Cancel
              </Button>
            </DialogClose>
            <Button
              onClick={handleSave}
              disabled={!name.trim() || !contents.trim() || !formulation}
            >
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddBrandDrugModal;
